export default {
    'pre-call-analysis': 'Pre call analysis',
    'call': 'Call'
}